import errorPage from '../../assets/images/error-page.png'
import Box from "@material-ui/core/Box";

const ErrorPage = () => {
    return (
        <Box
            component="img"
            sx={{
                width: "100%",
                height: "99.6vh",
            }}
            src={errorPage}
        />
    )
}

export default ErrorPage;
